import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function PolicyLayout({ title, updated, children }) {
  useEffect(() => {
    document.title = `${title} · Pickle Wall™`;
  }, [title]);

  return (
    <main id="main-content" className="bg-[#0a0a0a] text-white min-h-screen">
      <Navbar />
      <div className="max-w-3xl mx-auto px-6 md:px-10 pt-32 md:pt-44 pb-24">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-[#FF6B00] transition-colors mb-8"
        >
          <ArrowLeft size={16} />
          Back Home
        </Link>
        <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#FF6B00] mb-4">
          Legal
        </div>
        <h1 className="font-display text-4xl md:text-5xl font-black uppercase tracking-tight leading-[0.95]">
          {title}
        </h1>
        {updated && (
          <p className="mt-3 text-sm text-white/40">Last updated: {updated}</p>
        )}
        <div className="mt-10 space-y-6 text-white/75 leading-relaxed text-base">
          {children}
        </div>
        <div className="mt-14 pt-8 border-t border-white/10 text-sm text-white/50">
          Questions? Reach us at{" "}
          <a href="mailto:jcd@itspicklewall.com" className="text-[#FF6B00] hover:underline">
            jcd@itspicklewall.com
          </a>
          .
        </div>
      </div>
      <Footer />
    </main>
  );
}
